/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  Input, OnChanges,
  OnInit, SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import {CarouselDataModel} from './models/carousel-data.model';
import {CarouselSeverityTypeEnum} from './configuration/carousel-severity-type.enum';
import {StatefulComponent} from '../stateful/stateful.component';
import {CarouselState} from './models/carousel.state';
import {CarouselDataStatusEnum} from './models/carousel-data-status.enum';
import {CarouselDirectionEnum} from './models/carousel-direction.enum';
import {CarouselStateDataModel} from './models/carousel-state-data.model';
import {fastDeepCopy} from '../utils/deep-copy';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarouselComponent extends StatefulComponent<CarouselState> implements OnInit, OnChanges {
    @Input() carouselData: CarouselDataModel[];
    @Input() carouselSeverityType: CarouselSeverityTypeEnum;
    carouselDirectionRight = CarouselDirectionEnum.RIGHT;
    carouselDirectionLeft = CarouselDirectionEnum.LEFT;
    carouselSeverityTypeInfo = CarouselSeverityTypeEnum.INFO;

    constructor() {
        super();
    }


    getCarouselData(): CarouselStateDataModel[] {
        const carousel: CarouselStateDataModel[] = [];
        this.carouselData?.forEach((item: CarouselDataModel, index) => {
            carousel.push({
                title: item.title,
                description: item.description,
                status: index === 0 ? CarouselDataStatusEnum.ACTIVE : CarouselDataStatusEnum.DISABLED
            });
        });
        return carousel;
    }


    ngOnInit(): void {
        this.storeState({carousel: this.getCarouselData()});
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['carouselData']?.previousValue !== changes['carouselData']?.currentValue) {
            this.state.carousel = this.getCarouselData();
        }
    }

    getDotClass(status: string): string {
        return (status === CarouselDataStatusEnum.ACTIVE) ? CarouselDataStatusEnum.ACTIVE : undefined;
    }

    getShowCarouselClass(status: string): string {
        return (status === CarouselDataStatusEnum.ACTIVE) ? CarouselDataStatusEnum.ACTIVE : CarouselDataStatusEnum.DISABLED;
    }

    carouselArrowDirection(direction: CarouselDirectionEnum): void {
        const activeIndex = this.state.carousel.findIndex((item) => item.status === CarouselDataStatusEnum.ACTIVE);
        const lastIndex = this.state.carousel.length - 1;
        let newIndex = 0;

        if (this.state.carousel.length > 1 && this.state.carousel[activeIndex] != null) {
            this.state.carousel[activeIndex].status = CarouselDataStatusEnum.DISABLED;

            if (direction === CarouselDirectionEnum.RIGHT) {
                newIndex = activeIndex === lastIndex ? 0 : activeIndex + 1;
            } else if (direction === CarouselDirectionEnum.LEFT) {
                newIndex = activeIndex === 0 ? lastIndex : activeIndex - 1;
            }

            this.state.carousel[newIndex].status = CarouselDataStatusEnum.ACTIVE;
        }

    }

    displayNavigation(): boolean {
        return this.state.carousel?.length > 1;
    };

    closeCarouselBox(index: number): void {
        this.state.carousel.splice(index, 1);
        if (this.state.carousel.length > 0) {
            const newIndex = index <= this.state.carousel.length - 1 ? index : 0;
            this.state.carousel[newIndex].status = CarouselDataStatusEnum.ACTIVE;
        }
    }

    carouselDotsClick(index: number): void {
        if (this.state.carousel.length > 0) {
            this.state.carousel.find((item) => item.status === CarouselDataStatusEnum.ACTIVE).status = CarouselDataStatusEnum.DISABLED;
            this.state.carousel[index].status = CarouselDataStatusEnum.ACTIVE;
        }
    }
}
